if (!customElements.get('brand-bar')) {
  customElements.define(
    'brand-bar',
    class BrandBar extends HTMLElement {
      constructor() {
        super();

        this.viewportWidth = document.documentElement.clientWidth;

      }

      connectedCallback() {
        window.addEventListener('resize', debounce((event) => {
          if(document.documentElement.clientWidth === this.viewportWidth) return;
          this.onResize();
        }, ON_CHANGE_DEBOUNCE_TIMER));

        this.onResize();
      }

      getChildrenTotalWidth(element) {
        if(!element || !element.children) return;
        return Array.from(element.children).reduce((acc, curVal) => curVal.clientWidth + acc, 0);
      }

      pause() {
        setTimeout(() => {
          Array.from(this.querySelectorAll('[data-animation]')).filter(el => el.dataset.animation !== 'disabled').forEach(el => el.classList.remove(`playing-${el.dataset.animation}`));
        });
      }

      play() {
        setTimeout(() => {
          Array.from(this.querySelectorAll('[data-animation]')).filter(el => el.dataset.animation !== 'disabled').forEach(el => el.classList.add(`playing-${el.dataset.animation}`));
        }, 100);
      }

      onResize = (force = false) => {
        this.viewportWidth = document.documentElement.clientWidth;
        this.pause();
        this.deleteClones();
        this.addClones();
        this.play();
      };

      addClones() {
        Array.from(this.children).forEach((childEl) => {
          childEl.classList.remove('cloned');
          if(childEl.dataset.animation !== 'disabled' || childEl.classList.contains('brand_bar--heading')) {
            const listEl = childEl.querySelector('ul');
            let totalWidth = this.getChildrenTotalWidth(listEl);

            do {
              listEl.querySelectorAll('li:not(.clone)').forEach((listItemEl) => {
                const currentClone = listItemEl.cloneNode(true);
                currentClone.classList.add('clone');
                if(totalWidth < this.viewportWidth) listEl.appendChild(currentClone);

                // Avoid the appearance of a repeat by making sure the last clone isn't the same as the first element (unless we only have one element)
                if(listEl.querySelectorAll('li:not(.clone)').length === 1 ||  (listEl.querySelectorAll('li:not(.clone)').length > 1 && currentClone.innerHTML !== listEl.children.item(0).innerHTML)) totalWidth = this.getChildrenTotalWidth(listEl);
              });
            } while (totalWidth < this.viewportWidth);
            
            const containerClone = listEl.cloneNode(true);
            containerClone.setAttribute('aria-hidden', true);
            containerClone.classList.add('clone');
            childEl.appendChild(containerClone);
          }
          childEl.classList.add('cloned');
        });
      }
      
      deleteClones() {
        this.querySelectorAll('.clone').forEach((clonedEl) => clonedEl.remove());
      }

    }
  );
}
